import {createActionGroup, emptyProps} from '@ngrx/store';
import {Patron} from '@store/patron/patron.types';
import {OPACRegistrationValue, REGISTRATION_FEATURE_KEY, RegistrationStep} from '@store/registration/registration.types';

export const RegistrationActions = createActionGroup({
  source: REGISTRATION_FEATURE_KEY,
  events: {
    'Show Create Account': emptyProps(),

    'Update Registration': (value: Partial<OPACRegistrationValue>) => ({value}),
    'Complete Registration Step': (step: RegistrationStep) => ({step}),

    'Lookup Account': (cardNumber: string, PIN: string) => ({cardNumber, PIN}),
    'Lookup Account Success': (cardNumber: string, PIN: string, patron: Patron) => ({cardNumber, PIN, patron}),
    'Lookup Account Failure': (error: unknown) => ({error}),

    'Validate Patron Email Available': (email: string) => ({email}),
    'Validate Patron Email Available Success': (isAvailable: boolean) => ({isAvailable}),
    'Validate Patron Email Available Failure': (error: unknown) => ({error}),

    'Request Verification Email': (email?: string) => ({email}),
    'Request Verification Email Success': (email: string, verificationUUID: string) => ({email, verificationUUID}),
    'Request Verification Email Failure': (error: unknown) => ({error}),

    'Check Verification Status': (verificationUUID: string) => ({verificationUUID}),
    'Check Verification Status Success': emptyProps(),
    'Check Verification Status Failure': (error: unknown) => ({error}),
    'Set Verification Expired': (isExpired: boolean) => ({isExpired}),

    'Verify Email': (code: string, attachedVerificationUUID?: string) => ({code, attachedVerificationUUID}),
    'Verify Email Success': emptyProps(),
    'Verify Email Failure': (error: unknown) => ({error}),

    'Register Login Patron': (email: string, password: string) => ({email, password}),

    'Register': emptyProps(),
    'Register Success': emptyProps(),
    'Register Failure': (error: unknown) => ({error}),

    'Register Existing': emptyProps(),
    'Register Existing Success': emptyProps(),
    'Register Existing Failure': (error: unknown) => ({error}),
  }
});
